import React from 'react'
import Header from '../components/header/Header'
import BannerThree from '../components/banner/BannerThree'
import AboutOne from '../components/about/AboutOne'
import FeatureTwo from '../components/features/FeatureTwo'
import RoadmapOne from '../components/roadmap/RoadmapOne'
import TokenomicsThree from '../components/tokenomics/TokenomicsThree'
import CountDown from '../components/countdown/CountDown'
import Faq from '../components/faq/Faq'
import ContactTwo from '../components/contact/ContactTwo'
import Footer from '../components/footer/Footer'
import Script from '../components/script/Script'

function HomeThree() {
  return (
    <>
            <div className="rts-wrapper">
                <div className="rts-wrapper-inner">
                    <Header />
                    <BannerThree />
                    <AboutOne className="rts-section-gap"/>
                    <FeatureTwo />
                    <RoadmapOne />
                    <TokenomicsThree />
                    <CountDown />
                    <Faq />
                    <ContactTwo className="rts-section-gapBottom"/>
                </div>
            </div>
            <Footer className="bg-two"/>
            <Script />
        </>
  )
}

export default HomeThree